<template>
  <i class="material-icons action-icon" @click="archiveCategory">
    archive
  </i>
</template>

<script>
import db from "../db.js";
import eventHub from "../eventHub.js";

export default {
  name: "archive-category",
  props: {
    categoryId: String,
  },
  methods: {
    archiveCategory() {
      let really = confirm("Are you sure you want to archive this category and all subcategories?");

      if (really) {
        db.archiveCategory(this.categoryId);
        eventHub.$emit("set-category-modal-visibility", { isVisible: false });
      }
    },
  },
};
</script>

<style scoped>
.material-icons.action-icon {
  font-size: 24px;
  margin: 0.25rem;
  color: #c0c0c0;
}

.material-icons.action-icon:hover {
  color: #e74c3c;
}
</style>



// WEBPACK FOOTER //
// ArchiveCategory.vue?3a7bba88